module.exports = __webpack_public_path__ + "static/img/card.c154068.png";